import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ViolationSeverityDashboard = ({ statistics, loading, onRefresh }) => {
  if (loading) {
    return (
      <div className="bg-card border border-border rounded-lg p-6">
        <div className="flex items-center justify-center py-12">
          <Icon name="Loader2" size={32} color="var(--color-primary)" className="animate-spin" />
        </div>
      </div>
    );
  }

  const stats = statistics || {
    total: 0,
    critical: 0,
    active: 0,
    resolved: 0,
    totalCost: 0,
    affectedEmployees: 0,
    remediationSuccessRate: 0
  };

  return (
    <div className="space-y-4">
      {/* Critical Alerts Card */}
      <div className="bg-gradient-to-br from-error/10 to-error/5 border border-error/20 rounded-lg p-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-heading font-semibold text-base text-foreground">Critical Alerts</h3>
          <Icon name="AlertTriangle" size={20} color="var(--color-error)" />
        </div>
        <div className="text-center">
          <div className="text-5xl font-bold text-error mb-2">{stats?.critical}</div>
          <p className="text-sm text-muted-foreground">Require Immediate Action</p>
        </div>
      </div>

      {/* Active Violations Card */}
      <div className="bg-gradient-to-br from-warning/10 to-warning/5 border border-warning/20 rounded-lg p-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-heading font-semibold text-base text-foreground">Active Violations</h3>
          <Icon name="AlertCircle" size={20} color="var(--color-warning)" />
        </div>
        <div className="text-center">
          <div className="text-5xl font-bold text-warning mb-2">{stats?.active}</div>
          <p className="text-sm text-muted-foreground">Pending Resolution</p>
        </div>
      </div>

      {/* Remediation Success Rate Card */}
      <div className="bg-gradient-to-br from-success/10 to-success/5 border border-success/20 rounded-lg p-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-heading font-semibold text-base text-foreground">Success Rate</h3>
          <Icon name="CheckCircle2" size={20} color="var(--color-success)" />
        </div>
        <div className="text-center">
          <div className="text-5xl font-bold text-success mb-2">{stats?.remediationSuccessRate}%</div>
          <p className="text-sm text-muted-foreground">Remediation Success</p>
        </div>
      </div>

      {/* Client Impact Metrics Card */}
      <div className="bg-gradient-to-br from-primary/10 to-primary/5 border border-primary/20 rounded-lg p-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-heading font-semibold text-base text-foreground">Impact Metrics</h3>
          <Icon name="Users" size={20} color="var(--color-primary)" />
        </div>
        <div className="space-y-3">
          <div className="flex items-center justify-between">
            <span className="text-sm text-muted-foreground">Affected Employees</span>
            <span className="text-lg font-bold text-primary">{stats?.affectedEmployees}</span>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-sm text-muted-foreground">Total Cost Impact</span>
            <span className="text-lg font-bold text-warning">K{stats?.totalCost?.toFixed(2)}</span>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-sm text-muted-foreground">Resolved Issues</span>
            <span className="text-lg font-bold text-success">{stats?.resolved}</span>
          </div>
        </div>
      </div>

      {/* Refresh Button */}
      <Button
        variant="outline"
        size="sm"
        onClick={onRefresh}
        iconName="RefreshCw"
        className="w-full"
      >
        Refresh Dashboard
      </Button>
    </div>
  );
};

export default ViolationSeverityDashboard;